import * as React from "react";
import * as classNames from "classnames";
import Dropzone from "react-dropzone";

interface IFileDropZoneProps {
    className?: string;
    theme?: any;
}

interface IFileDropZoneActions {
    onDrop(acceptedFiles: File[], rejectedFiles?: File[]): void
}

type FileDropZonePropsAndActions = IFileDropZoneProps & IFileDropZoneActions;

class FileDropZone extends React.PureComponent<FileDropZonePropsAndActions, any> {
    render() {
        return (
            <Dropzone onDrop={this.props.onDrop}>
                {({ getRootProps, getInputProps, isDragActive }) => {
                    return (
                        <div
                            {...getRootProps()}
                            className={classNames(this.props.theme, this.props.className, 'dropzone', { 'drag-active': isDragActive })}
                        >
                            <input {...getInputProps()} />
                            {
                                <div className="text-center dropzone-inner">
                                    <i
                                        className={classNames("fa fa-cloud-upload fa-3x dropzone-icon")}
                                        aria-hidden="true"
                                    />
                                    <br />
                                    Drop some files here, or click to select files to upload.
                                </div>
                            }
                        </div>
                    )
                }}
            </Dropzone>
        );
    }
}

export default FileDropZone;